import { render } from "./EditCustomerForm.vue?vue&type=template&id=eb0b3f68&scoped=true"
import script from "./EditCustomerForm.vue?vue&type=script&lang=js"
export * from "./EditCustomerForm.vue?vue&type=script&lang=js"

import "./EditCustomerForm.vue?vue&type=style&index=0&id=eb0b3f68&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb0b3f68"]])

export default __exports__